<template>
    <el-card class="box-card">
        <el-row>
            <SearchBox ref="SearchBox">
                <el-form slot="form" :inline="true" ref="searchData" :model="searchParams" label-width="80px"
                         class="unitWidth" size="small">
                    <el-form-item label="统计维度" style="display: inline-block">
                        <el-select v-model="typeDissection" clearable>
                            <el-option value="shopBy" label="车间">车间</el-option>
                            <el-option value="lineBy" label="产线">产线</el-option>
                            <el-option value="devCodeBy" label="设备">设备</el-option>
                            <el-option value="responserBy" label="维修人">维修人</el-option>
                            <el-option value="dayBy" label="天">天</el-option>
                            <!--                            <el-option value="probPartBy" label="故障位置">故障位置</el-option>
                        <el-option value="statusBy" label="维修状态">维修状态</el-option>
                        <el-option value="requesterBy" label="报修人">报修人</el-option> -->
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属工厂">
                        <el-select v-model="mechanism.fcCode" placeholder="请选择" :clearable="isclear" :disabled="ischeck"
                                   filterable @change="fcChange">
                            <el-option v-for="factory in factoryList" :key="factory.value" :label="factory.label"
                                       :value="factory.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属车间">
                        <el-select v-model="mechanism.shopCode" placeholder="请选择" clearable filterable
                                   @change="shopChange">
                            <el-option v-for="shop in shopList" :key="shop.value" :label="shop.label"
                                       :value="shop.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属工段">
                        <el-select v-model="mechanism.sectionCode" placeholder="请选择" clearable filterable
                                   @change="sectionChange">
                            <el-option v-for="section in sectionList" :key="section.value" :label="section.label"
                                       :value="section.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属产线">
                        <el-select v-model="mechanism.lineCode" placeholder="请选择" clearable filterable
                                   @change="lineChange">
                            <el-option v-for="line in lineList" :key="line.value" :label="line.label"
                                       :value="line.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="设备编号">
                        <el-select v-model="searchParams.devCode" placeholder="请选择" clearable filterable>
                            <el-option v-for="device in deviceInfoList" :key="device.devId"
                                       :label="'(' + device.devCode + ')' + device.devName"
                                       :value="device.devCode"></el-option>
                        </el-select>
                    </el-form-item>
                    <!--<el-form-item label="响应人">
                        <el-input v-model="searchParams.andonRespUserName" @on-change="requestChange"></el-input>
                    </el-form-item>-->
                    <!-- <el-form-item label="故障部位">
                    <el-input v-model="searchParams.probPart" @on-change="probPartChange"></el-input>
                </el-form-item>
                <el-form-item label="维修状态">
                      <el-select   clearable  v-model="searchParams.andonStatus" @on-change="mainChange">
                            <el-option :value="MainStutas.value" :label="MainStutas.label"  v-for="MainStutas  in MainStutaslist">{{MainStutas.label}}</el-option>
                      </el-select>
                  </el-form-item>
                <el-form-item label="报修人">
                    <el-input v-model="searchParams.pubUserName"  @on-change="requestChange"></el-input>
                </el-form-item> -->
                    <!--<el-form-item label="响应时长">
                        <el-input v-model="searchParams.responseTimeQueryHour"
                                  @on-change="responserTimeChange"></el-input>
                    </el-form-item>
                    <el-form-item label="修复时长">
                        <el-input v-model="searchParams.probTimeQueryHour" @on-change="probTimeChange"></el-input>
                    </el-form-item>
                    <el-form-item label="是否转单" style="display: inline-block">
                        <el-select clearable v-model="searchParams.moHasTrans" @on-change="hasTransChange">
                            <el-option value="true" label="是">是</el-option>
                            <el-option value="false" label="否">否</el-option>
                        </el-select>
                    </el-form-item>-->
                    <el-form-item label="选择日期">
                        <el-date-picker
                            style="width: 20vw;"
                            type="daterange"
                            value-format="yyyy-MM-dd"
                            v-model="dataTime"
                            transfer
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            show-week-numbers
                            placement="bottom-end"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item style="margin-left: 20px">
                        <el-button type="primary" @click="getStatistics">查询</el-button>
                        <el-button type="primary" @click="exportStatistics" style="margin-left: 10px">导出</el-button>
                        <el-button type="success" @click="onShowPersonnelCost()">人员成本</el-button>
                        <!--<el-button type="success" @click="getRoleInfo()">新增人员成本</el-button>-->
                    </el-form-item>
                </el-form>
            </SearchBox>
        </el-row>
        <el-row>
            <el-card>
                <el-table border stripe fit highlight-current-row :data="tempData">
                    <el-table-column v-for="item in itemOptions" :key="item.id" :label="item.title" :prop="item.key"
                                     :width="item.width"
                                     sortable align="center" show-overflow-tooltip>       
                        <template slot-scope="scope">
                            <span>{{ scope.row[item.key] }}</span>          
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    @size-change="paginationChange"
                    @current-change="paginationCurrentChange"
                    :current-page="searchParams.pageNumber"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="searchParams.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="searchParams.total"
                />
            </el-card>
            <el-dialog title="人员成本信息" :visible.sync="personnelTableVisible">
                <div style="text-align: left;text-align: left;margin-top: 1.5vw;">
                    <div style="margin: 10px">
                        <span>人员角色：</span>
                        <el-select v-model="personnelCost.roleId" placeholder="请选择" filterable @change="personSelect">
                            <el-option v-for="role in roleListToSelect" :label="role.roleName" :value="role.roleId"
                                       :key="role.roleId"></el-option>
                        </el-select>
                        <span style="margin-left: 1.2vw">成本价格：</span>
                        <el-input-number v-model="personnelCost.costPrice" :precision="2" :min="0"
                                         :step="0.1"></el-input-number>
                        <el-button style="margin-left: 1.2vw" @click="editPersonnelCostInfo">选择提交
                        </el-button>
                    </div>
                </div>
                <el-table :data="personnelCostList">
                    <el-table-column align="center" property="roleName" label="角色名称"></el-table-column>
                    <el-table-column align="center" property="costPrice" label="人工单价(时薪)"></el-table-column>
                    <el-table-column align="center" property="createName" label="创建人"></el-table-column>
                    <el-table-column align="center" property="createTime" label="创建时间"></el-table-column>
                    <el-table-column align="center" label="操作" width="100">
                        <template slot-scope="scope">
                            <i class="editBtn iconfont u-youjianbianji" @click="editPersonnel(scope.row)"/>
                            <i class="delBtn iconfont u-shanchu" @click="deletePersonnelCostInfo(scope.row.costId)"/>
                        </template>
                    </el-table-column>
                </el-table>
            </el-dialog>
            <el-dialog title="新增人员成本信息" :visible.sync="addPersonnelTableVisible" width="30%">
                <el-form :model="personnelCost" class="demo-roleForm">
                    <el-form-item label="人员角色">
                        <el-select style="margin-left: 1.2vw" v-model="personnelCost.roleId" placeholder="请选择">
                            <el-option v-for="role in roleInfo" :label="role.roleName" :value="role.roleId"
                                       :key="role.roleId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="成本价格">
                        <el-input-number v-model="personnelCost.costPrice" :precision="2" :min="0"
                                         :step="0.1"></el-input-number>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
            <el-button @click="addPersonnelTableVisible = false">取 消</el-button>
            <el-button type="primary" @click="editPersonnelCostInfo('personnelCost')">确认</el-button>
        </span>
            </el-dialog>
        </el-row>
    </el-card>
</template>
<script>
    const { export_json_to_excel } = require('../../vendor_excel/Export2Excel.js')
    import {
        getCostStatistics,
        exportCostStatistics,
        getPersonnelCost,
        editPersonnelCost,
        delPersonnelCost
    } from '../../../api/reportform.js'
    import { getRole } from '../../../api/role.js'

    export default {
        name: 'CostReport',
        data: function() {
            return {
                roleInfo: [],
                roleListToSelect: [],
                personnelCost: {
                    costPrice: 0,
                    roleId: 0
                },
                personnelCostList: [],
                addPersonnelTableVisible: false,
                personnelTableVisible: false,
                itemOptions: [],
                MainStutaslist: [
                    { value: 'create', label: '待接单' },
                    { value: 'wait_complete', label: '待维修' },
                    { value: 'wait_accept', label: '待完成' },
                    { value: 'complete', label: '已完成' }
                ],
                mechanism: {
                    fcCode: '',
                    shopCode: '',
                    sectionCode: '',
                    lineCode: ''
                },
                searchParams: {
                    pageSize: 10,
                    pageNumber: 1,
                    total: 0,
                    fcCode: '',
                    shopCode: '',
                    sectionCode: '',
                    lineCode: '',
                    devCode: '',
                    sortSelected: '',
                    sort: '',
                    number: '',
                    startTime: '',
                    endTime: '',
                    responser: '',
                    probPart: '',
                    status: '',
                    pubUserName: '',
                    responseTimeQueryHour: '',
                    probTimeQueryHour: '',
                    moHasTrans: '',
                    andonRespUserName: ''

                },
                isclear: false,
                factoryData: [],
                access: [],
                role: [],
                ischeck: true,
                scopeDisabled: '',
                factoryTree: [],
                addShow: false,
                userInfo: {},
                fcIdSelected: '',
                twoAnalyze: [],
                dataTime: [],
                mainOrderList: '',
                typeDissection: 'dayBy',
                queryParam: {},
                data5: [],
                tempData: [],
                deviceInfoList: []
            }
        },
        computed: {
            factoryList: function() {
                var arr = []
                var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
                if (this.factoryTree != undefined && this.factoryTree.length > 0) {
                    if (this.ischeck) {
                        for (var i = 0; i < this.factoryTree.length; i++) {
                            for (let j = 0; j < userInfo.roles.length; j++) {
                                if (this.factoryTree[i].deptID == userInfo.roles[j].factoryId) {
                                    arr.push({
                                        label: this.factoryTree[i].deptName,
                                        id: this.factoryTree[i].deptID,
                                        value: JSON.stringify(this.factoryTree[i]),
                                        deptLevel: this.factoryTree[i].deptLevel,
                                        parent: 0
                                    })
                                }
                            }
                        }
                    } else {
                        for (var i = 0; i < this.factoryTree.length; i++) {
                            arr.push({
                                label: this.factoryTree[i].deptName,
                                id: this.factoryTree[i].deptID,
                                value: JSON.stringify(this.factoryTree[i]),
                                deptLevel: this.factoryTree[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            shopList: function() {
                var arr = []
                if (this.mechanism.fcCode != undefined && this.mechanism.fcCode.length > 0) {

                    var factory = JSON.parse(this.mechanism.fcCode)
                    var shops = factory.child
                    for (var i = 0; i < shops.length; i++) {
                        if (shops[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: shops[i].deptName,
                                id: shops[i].deptID,
                                value: JSON.stringify(shops[i]),
                                deptLevel: shops[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            sectionList: function() {
                var arr = []
                if (this.mechanism.shopCode != undefined && this.mechanism.shopCode.length > 0) {
                    var shop = JSON.parse(this.mechanism.shopCode)
                    var vsms = shop.child
                    for (var i = 0; i < vsms.length; i++) {
                        if (vsms[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: vsms[i].deptName,
                                id: vsms[i].deptID,
                                value: JSON.stringify(vsms[i]),
                                deptLevel: vsms[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            lineList: function() {
                var arr = []
                if (this.mechanism.sectionCode != undefined && this.mechanism.sectionCode.length > 0) {
                    var vsm = JSON.parse(this.mechanism.sectionCode)
                    var lines = vsm.child
                    for (var i = 0; i < lines.length; i++) {
                        if (lines[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: lines[i].deptName,
                                id: lines[i].deptID,
                                value: JSON.stringify(lines[i]),
                                deptLevel: lines[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            }
        },
        mounted() {
            this.init()
        },
        methods: {
            init: function() {
                this.access = JSON.parse(sessionStorage.getItem('auths'))
                // this.userInfo = sessionStorage.getItem("userInfo")
                this.userInfo = this.$store.state.userInfo
                var role = this.userInfo.roles
                for (var i = 0; i < role.length; i++) {
                    //所有工厂数据
                    if (role[i].factoryId == 0) {
                        this.ischeck = false
                        this.role = role[i]
                        this.scopeDisabled = false
                        this.isclear = true
                        break
                    } else {
                        if (this.userInfo.factoryId == role[i].factoryId) {
                            this.role = role[i]
                        }
                    }
                }
                // this.getFactory()
                this.getData()
            },
            paginationChange(val) {
                this.searchParams.pageSize = val
                this.getStatistics()

            },
            paginationCurrentChange(val) {
                this.searchParams.pageNumber = val
                this.getStatistics()
            },
            fcChange: function() {
                this.mechanism.shopCode = ''
                this.mechanism.sectionCode = ''
                this.mechanism.lineCode = ''
                this.searchParams.devCode = ''
                this.getDeviceInfoList()
            },
            shopChange: function() {
                this.mechanism.sectionCode = ''
                this.mechanism.lineCode = ''
            },
            sectionChange: function() {
                this.mechanism.lineCode = ''
            },
            lineChange: function() {
            },
            onShowPersonnelCost() {
                if (this.mechanism.fcCode == undefined || this.mechanism.fcCode == '') {
                    this.$message.error('请选择工厂！')
                    return
                }
                this.personnelTableVisible = true
                this.getRoleInfo()
            },
            editPersonnel(row) {
                var flag = true
                if (this.roleListToSelect.length != 0) {
                    for (let a0 = 0; a0 < this.roleListToSelect.length; a0++) {
                        if (row.roleId == this.roleListToSelect[a0].roleId) {
                            flag = false
                        }
                    }
                }
                if (flag) {
                    let array = {
                        costId: '',
                        roleId: '',
                        roleName: '',
                        costPrice: ''
                    }
                    for (let i = 0; i < this.personnelCostList.length; i++) {
                        if (row.roleId == this.personnelCostList[i].roleId) {
                            array.costId = row.costId
                            array.roleId = this.personnelCostList[i].roleId
                            array.roleName = this.personnelCostList[i].roleName
                            this.personnelCost.roleId = this.personnelCostList[i].roleId
                            this.personnelCost.costPrice = this.personnelCostList[i].costPrice
                        }
                    }
                    this.roleListToSelect.push(array)
                }
            },
            personSelect() {
                let flag = true
                let costPrice = ''
                for (let i = 0; i < this.roleListToSelect.length; i++) {
                    if (this.personnelCost.roleId == this.roleListToSelect[i].roleId) {
                        if (this.roleListToSelect[i].costId != undefined && this.roleListToSelect[i].costId != '') {
                            flag = false
                        }
                    }
                }
                if (!flag) {
                    for (let a0 = 0; a0 < this.personnelCostList.length; a0++) {
                        if (this.personnelCost.roleId == this.personnelCostList[a0].roleId) {
                            costPrice = this.personnelCostList[a0].costPrice
                        }
                    }
                    this.personnelCost.costPrice = costPrice
                } else {
                    this.personnelCost.costPrice = ''
                }
                //强制刷新
                this.$forceUpdate()
            },
            editPersonnelCostInfo() {
                var self = this
                let flag = true
                if (self.personnelCost.costPrice == undefined || self.personnelCost.costPrice == null) {
                    self.$message.error('请输入成本价格!')
                    return
                }
                if (self.personnelCost.roleId == undefined || self.personnelCost.roleId == null) {
                    self.$message.error('请选择人员角色!')
                    return
                }
                for (let i = 0; i < self.roleListToSelect.length; i++) {
                    if (self.personnelCost.roleId == self.roleListToSelect[i].roleId) {
                        if (self.roleListToSelect[i].costId != undefined && self.roleListToSelect[i].costId != '') {
                            self.personnelCost.costId = self.roleListToSelect[i].costId
                            flag = false
                        }
                    }
                }
                self.personnelCost.fcCode = JSON.parse(self.mechanism.fcCode).deptCode
                editPersonnelCost(self.personnelCost).then(function(resp) {
                    if (resp.status == 100) {
                        self.personnelCost = {}
                        self.getPersonnelCostInfo()
                        self.$message.success(flag ? '新增成功！' : '编辑成功！')
                    } else {
                        self.$message.success(resp.message)
                    }
                })
            },
            deletePersonnelCostInfo(costId) {
                this.$confirm('是否确定删除该数据, 是否继续?', '提示', {
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        delPersonnelCost(costId)
                            .then(response => {
                                this.getPersonnelCostInfo()
                                // this.$message.success(response.message);
                            })
                            .catch(err => {
                                this.getPersonnelCostInfo()
                                // this.$message.error(err);
                            })
                    })
                    .catch(() => {
                        this.getPersonnelCostInfo()
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        })
                    })
            },
            getRoleInfo() {
                var self = this
                self.personnelCost = {}
                var params = {
                    fcCode: JSON.parse(self.mechanism.fcCode).deptCode
                }
                let options = {
                    method: 'get',
                    url: this.$api.getRoleList,
                    params: params
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        if (response.data) {
                            self.roleInfo = response.data
                            self.getPersonnelCostInfo()
                        }
                    } else {
                        self.$message.success('查询失败!')
                    }
                })
            },
            getPersonnelCostInfo() {
                var self = this
                var params = {
                    fcCode: JSON.parse(self.mechanism.fcCode).deptCode
                }
                getPersonnelCost(params).then(function(resp) {
                    if (resp.status == 100) {
                        self.roleListToSelect = JSON.parse(JSON.stringify(self.roleInfo))
                        if (undefined == resp.data || null == resp.data) {
                            self.personnelCostList = []
                        } else {
                            self.personnelCostList = resp.data
                            self.personnelCostList.forEach(person => {
                                for (var i = self.roleListToSelect.length - 1; i >= 0; i--) {
                                    if (self.roleListToSelect[i].roleId == person.roleId)
                                        self.roleListToSelect.splice(i, 1)
                                }
                            })
                        }
                    } else {
                        self.$message.error('查询失败!')
                    }

                })
            },
            getFactory() {
                let queryParams = {
                    fcCode: this.userInfo.fcCode
                }
                let options = {
                    methods: 'GET',
                    url: this.$api.getAllFactory,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.factoryData = response.data
                    }
                })
            },
            getDeviceInfoList() {
                this.deviceInfoList = []
                let self = this
                let params = {}
                if (self.mechanism.fcCode != undefined && self.mechanism.fcCode != '') {
                    params['fcCode'] = JSON.parse(self.mechanism.fcCode).deptCode
                } else {
                    return
                }
                let options = {
                    method: 'GET',
                    url: this.$api.deviceInfoList,
                    params: params
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.deviceInfoList = response.data
                    }
                })
            },
            getData() {
                var self = this
                let options = {
                    method: 'GET',
                    url: this.$api.departTree
                }
                this.$http.request(options).then(response => {
                    this.factoryTree = response.data
                    for (var i = 0; i < self.factoryTree.length; i++) {
                        if (self.factoryTree[i].deptID == self.role.factoryId) {
                            self.mechanism.fcCode = JSON.stringify(self.factoryTree[i])
                        }
                    }
                    this.getDeviceInfoList()
                    this.getStatistics()
                })
            },
            getdatarange: function() {
                if (this.dataTime.length > 0 && this.dataTime[0] != '' && this.dataTime[1] != '') {
                    this.searchParams.startTime = this.dataTime[0]
                    this.searchParams.endTime = this.dataTime[1]
                }
                this.dateRange = this.data
            },
            getStatistics: function() {
                var self = this
                if (!self.typeDissection) {
                    self.$message.error('统计维度不能为空')
                    return
                }
                self.queryParam = {}

                var querydata = {
                    pageNum: self.searchParams.pageNumber,
                    pageSize: self.searchParams.pageSize
                }
                if (self.mechanism.fcCode != undefined && self.mechanism.fcCode != '') {
                    querydata['fcCode'] = JSON.parse(self.mechanism.fcCode).deptCode
                }
                if (self.mechanism.shopCode != undefined && self.mechanism.shopCode != '') {
                    querydata['shopCode'] = JSON.parse(self.mechanism.shopCode).deptCode
                }
                if (self.mechanism.sectionCode && self.mechanism.sectionCode != '') {
                    querydata['sectionCode'] = JSON.parse(self.mechanism.sectionCode).deptCode
                }
                if (self.mechanism.lineCode != undefined && self.mechanism.lineCode != '') {
                    querydata['lineCode'] = JSON.parse(self.mechanism.lineCode).deptCode
                }
                if (self.devCode != '') {
                    querydata['devCode'] = self.searchParams.devCode
                }
                if (self.searchParams.responser != '') {
                    querydata['andonRespUserName'] = self.searchParams.andonRespUserName
                }
                if (self.searchParams.probPart != '') {
                    querydata['probPart'] = self.searchParams.probPart
                }
                if (self.searchParams.andonStatus != '') {
                    querydata['andonStatus'] = self.searchParams.andonStatus
                }
                if (self.searchParams.pubUserName != '') {
                    querydata['pubUserName'] = self.searchParams.pubUserName
                }
                if (self.searchParams.responseTimeQueryHour != '') {
                    querydata['responseTimeQueryHour'] = self.searchParams.responseTimeQueryHour
                    querydata['responseTimeQuery'] = parseInt(self.searchParams.responseTimeQueryHour * 3600)
                }
                if (self.searchParams.probTimeQueryHour != '') {
                    querydata['probTimeQueryHour'] = self.searchParams.probTimeQueryHour
                    querydata['probTimeQuery'] = parseInt(self.searchParams.probTimeQueryHour * 3600)
                }
                if (self.typeDissection != '') {
                    querydata['typeDissection'] = self.typeDissection
                }
                if (self.searchParams.moHasTrans != '') {
                    querydata['moHasTrans'] = self.searchParams.moHasTrans
                }
                if (self.dataTime != null && self.dataTime != '') {
                    if (self.dataTime.length > 0 && self.dataTime[0] != '') {
                        querydata['startTime'] = self.$moment(self.dataTime[0]).format('YYYY-MM-DD') + ' 00:00:00'
                        querydata['endTime'] = self.$moment(self.dataTime[1]).format('YYYY-MM-DD') + ' 23:59:59'
                    }
                }
                getCostStatistics(querydata).then(function(resp) {
                    if (resp.status == 100) {
                        if (undefined == resp.data.list || null == resp.data.list) {
                            self.mainOrderList = []
                            self.searchParams.total = 0
                        } else {
                            self.mainOrderList = resp.data.list
                            self.searchParams.total = resp.data.total
                        }

                        self.typeBy = self.typeDissection
                        self.queryParam = querydata
                        self.getPageData()
                    } else {
                        self.$message.error('查询失败!')
                    }

                })

            },
            pagechange: function(index) {
                this.pageNum = index
                this.getPageData()
            },
            getAllFactory: function() {
                var self = this
                this.$http.request({
                    url: '/api/depart/depart_tree',
                    method: 'GET',
                    params: {
                        from: 'manage'
                    }
                }).then(function(resp) {
                    self.factoryTree = resp.data.data
                    for (var i = 0; i < self.factoryTree.length; i++) {
                        if (self.role.isAdmin == false && self.factoryTree[i].deptID == self.role.factoryId) {
                            self.fcIdSelected = JSON.stringify(self.factoryTree[i])
                        }
                    }
                    self.getStatistics()
                })
            },
            getPageData: function() {
                this.columnsChange()
            },
            columnsChange: function() {
                var self = this
                if (self.typeDissection == 'dayBy') {
                    self.itemOptions = [
                        { title: '报修时间', key: 'createTime', sortable: true, width: '120' },
                        { title: '车间', key: 'shopName', sortable: true },
                        { title: '生产线', key: 'lineName', sortable: true, width: '110' },
                        { title: '设备编号', key: 'devCode', sortable: true, width: '110' },
                        { title: '设备名称', key: 'devName', sortable: true, width: '120' },
                        { title: '维修人', key: 'andonRespUserName', sortable: true, width: '110' }
                    ]
                }
                if (self.typeDissection == 'devCodeBy') {
                    self.itemOptions = [
                        { title: '报修时间', key: 'createTime', sortable: true, width: '120' },
                        { title: '车间', key: 'shopName', sortable: true },
                        { title: '生产线', key: 'lineName', sortable: true, width: '110' },
                        { title: '设备编号', key: 'devCode', sortable: true, width: '110' },
                        { title: '设备名称', key: 'devName', sortable: true, width: '120' },
                        { title: '维修人', key: 'andonRespUserName', sortable: true, width: '110' }
                    ]
                }
                if (self.typeDissection == 'responserBy') {
                    self.itemOptions = [
                        { title: '报修时间', key: 'createTime', sortable: true, width: '120' },
                        { title: '车间', key: 'shopName', sortable: true },
                        { title: '生产线', key: 'lineName', sortable: true, width: '110' },
                        { title: '设备编号', key: 'devCode', sortable: true, width: '110' },
                        { title: '设备名称', key: 'devName', sortable: true, width: '120' },
                        { title: '维修人', key: 'andonRespUserName', sortable: true, width: '110' }
                    ]
                }
                if (self.typeDissection == 'probPartBy') {
                    self.itemOptions = [
                        { title: '故障部位', key: 'probPart', sortable: true, width: '120' }
                    ]
                }
                if (self.typeDissection == 'statusBy') {
                    self.itemOptions = [
                        { title: '维修状态', key: 'andonStatus', sortable: true, width: '120' }
                    ]
                }
                if (self.typeDissection == 'requesterBy') {
                    self.itemOptions = [
                        { title: '报修人', key: 'pubUserName', sortable: true, width: '110' }
                    ]
                }
                if (self.typeDissection == 'lineBy') {
                    self.itemOptions = [
                        { title: '报修时间', key: 'createTime', sortable: true, width: '120' },
                        { title: '车间', key: 'shopName', sortable: true },
                        { title: '生产线', key: 'lineName', sortable: true, width: '110' },
                        { title: '设备编号', key: 'devCode', sortable: true, width: '110' },
                        { title: '设备名称', key: 'devName', sortable: true, width: '120' },
                        { title: '维修人', key: 'andonRespUserName', sortable: true, width: '110' }
                    ]
                }
                if (self.typeDissection == 'shopBy') {
                    self.itemOptions = [
                        { title: '报修时间', key: 'createTime', sortable: true, width: '120' },
                        { title: '车间', key: 'shopName', sortable: true },
                        { title: '生产线', key: 'lineName', sortable: true, width: '110' },
                        { title: '设备编号', key: 'devCode', sortable: true, width: '110' },
                        { title: '设备名称', key: 'devName', sortable: true, width: '120' },
                        { title: '维修人', key: 'andonRespUserName', sortable: true, width: '110' }
                    ]
                }
                self.itemOptions.push({ title: '次数', key: 'sumCount', sortable: true })
                self.itemOptions.push({ title: '响应时长(分)', key: 'responseTime', sortable: true, width: '130' })
                self.itemOptions.push({ title: '平均响应时长(分)', key: 'avgResponseTime', sortable: true, width: '160' })
                self.itemOptions.push({ title: '系统记录维修时长(分)', key: 'mainTime', sortable: true, width: '190' })
                self.itemOptions.push({ title: '故障总时长(分)', key: 'downTime', sortable: true, width: '140' })
                self.itemOptions.push({ title: 'MTTR(分)', key: 'MTTR', sortable: true, width: '100' })
                self.itemOptions.push({ title: 'MTBF(分)', key: 'MTBF', sortable: true, width: '100' })
                /*self.itemOptions.push({ title: '两小时修复率', key: 'twoRate', sortable: true, width: '130' })*/
                self.itemOptions.push({ title: '人员成本(元)', key: 'personnelCost', sortable: true, width: '120' })
                self.itemOptions.push({ title: '备件成本(元)', key: 'spareCost', sortable: true, width: '120' })
                self.itemOptions.push({ title: '总计成本(元)', key: 'totalCost', sortable: true, width: '120' })

                self.dataChange()
            },
            dataChange: function() {
                var self = this
                self.data5 = []
                for (var i = 0; i < self.mainOrderList.length; i++) {
                    var data = {}
                    if (self.typeDissection == 'dayBy') {
                        data.index = i + 1
                        data.createTime = self.mainOrderList[i].createTime
                    }
                    if (self.typeDissection == 'devCodeBy') {
                        data.index = i + 1
                        data.devCode = self.mainOrderList[i].devCode
                        data.devName = self.mainOrderList[i].devName
                    }
                    if (self.typeDissection == 'responserBy') {
                        data.index = i + 1
                        data.andonRespUserName = self.mainOrderList[i].andonRespUserName
                    }
                    if (self.typeDissection == 'probPartBy') {
                        data.index = i + 1
                        data.probPart = self.mainOrderList[i].probPart
                    }
                    if (self.typeDissection == 'statusBy') {
                        data.index = i + 1
                        if (self.mainOrderList[i].andonStatus == 'create') {
                            data.andonStatus = '待接单'
                        }
                        if (self.mainOrderList[i].andonStatus == 'wait_complete') {
                            data.andonStatus = '待维修'
                        }
                        if (self.mainOrderList[i].andonStatus == 'wait_accept') {
                            data.andonStatus = '待完成'
                        }
                        if (self.mainOrderList[i].andonStatus == 'complete') {
                            data.andonStatus = '已完成'
                        }

                    }
                    if (self.typeDissection == 'requesterBy') {
                        data.index = i + 1
                        data.pubUserName = self.mainOrderList[i].pubUserName
                    }
                    if (self.typeDissection == 'lineBy') {
                        data.index = i + 1
                        data.lineName = self.mainOrderList[i].lineName
                    }
                    if (self.typeDissection == 'shopBy') {
                        data.index = i + 1
                        data.shopName = self.mainOrderList[i].shopName
                    }
                    data.sumCount = self.mainOrderList[i].sumCount
                    data.avgResponseTime = self.mainOrderList[i].avgResponseTime ? Number(parseFloat(self.mainOrderList[i].avgResponseTime / 60).toFixed(2)) : 0
                    data.responseTime = self.mainOrderList[i].responseTime ? Number(parseFloat(self.mainOrderList[i].responseTime / 60).toFixed(2)) : 0
                    data.mainTime = self.mainOrderList[i].repairTime ? Number(parseFloat(self.mainOrderList[i].repairTime / 60).toFixed(2)) : 0
                    data.downTime = self.mainOrderList[i].probTime ? Number(parseFloat(self.mainOrderList[i].probTime / 60).toFixed(2)) : 0
                    // data.twoRate = self.mainOrderList[i].recoveryCount != null ? Number(String(parseFloat(self.mainOrderList[i].recoveryCount / self.mainOrderList[i].sumCount) * 100).substring(0, String(parseFloat(self.mainOrderList[i].recoveryCount / self.mainOrderList[i].sumCount) * 100).indexOf('.') + 3)) + '%' : '0'
                    // data.mtbf = self.mainOrderList[i].totalTime && self.mainOrderList[i].sumCount ? Number(parseFloat(self.mainOrderList[i].totalTime) / 60 / (self.mainOrderList[i].sumCount).toFixed(2)) : 0
                    // data.mttr = self.mainOrderList[i].repairTime && self.mainOrderList[i].sumCount ? Number(parseFloat(self.mainOrderList[i].repairTime) / 60 / (self.mainOrderList[i].sumCount).toFixed(2)) : 0
                    data.personnelCost = self.mainOrderList[i].personnelCost == undefined ? 0 : Number(parseFloat(self.mainOrderList[i].personnelCost).toFixed(3))
                    data.spareCost = self.mainOrderList[i].spareCost == undefined ? 0 : Number(parseFloat(self.mainOrderList[i].spareCost).toFixed(3))
                    data.totalCost = parseFloat(data.personnelCost) + parseFloat(data.spareCost)
                    data.MTTR = self.mainOrderList[i].repairTime && self.mainOrderList[i].sumCount ? Number(parseFloat(self.mainOrderList[i].repairTime) / 60 / (self.mainOrderList[i].sumCount).toFixed(2)) : 0
                    /*if (this.typeDissection == 'dayBy') {
                        //统计维度为天(24小时-今天故障总时长)除以次数
                        let sumMinute = 1440
                        let MTBF = Number(parseFloat((sumMinute - data.downTime) / self.mainOrderList[i].sumCount).toFixed(2))
                        MTBF = MTBF <= 0 ? 0 : MTBF
                        data.MTBF = MTBF
                    } else {
                        data.MTBF = self.mainOrderList[i].repairTime == 0 && self.mainOrderList[i].sumCount == 0 ? 0 :
                            Number(String((parseFloat(self.mainOrderList[i].repairTime) / 60 / self.mainOrderList[i].sumCount)).substring(0, String((parseFloat(self.mainOrderList[i].repairTime) / 60 / self.mainOrderList[i].sumCount)).indexOf('.') + 3))
                    }*/
                    if (this.typeDissection == 'responserBy' || this.typeDissection == 'dayBy') {
                        data.MTTR = ''
                        data.MTBF = ''
                    } else {
                        data.MTBF = self.mainOrderList[i].totalTime && self.mainOrderList[i].sumCount ? Number(parseFloat(self.mainOrderList[i].totalTime) / 60 / (self.mainOrderList[i].sumCount).toFixed(2)) : 0
                    }
                    data.cb = 0
                    self.data5.push(data)
                }
                self.tempData = []
                self.tempData = self.data5
            },
            getdatarange: function(data) {
                this.pageNum = 1
                this.dateRange = data
            },
            numberChange: function() {
                this.pageNum = 1
            },
            responserChange: function() {
                this.pageNum = 1
            },
            probPartChange: function() {
                this.pageNum = 1
            },
            mainChange: function() {
                this.pageNum = 1
            },
            requestChange: function() {
                this.pageNum = 1
            },
            responserTimeChange: function() {
                this.pageNum = 1
            },
            probTimeChange: function() {
                this.pageNum = 1
            },
            hasTransChange: function() {
                this.pageNum = 1
            },
            mainDetail: function(main) {
                if (this.typeBy == 'dayBy') {
                    this.queryParam['startTime'] = main.moRequestTime
                    this.queryParam['endTime'] = main.moRequestTime
                }
                if (this.typeBy == 'devNumberBy') {
                    this.queryParam['devNumber'] = main.devNumber
                }
                if (this.typeBy == 'responserBy') {
                    this.queryParam['moResponser'] = main.moResponser
                }
                if (this.typeBy == 'probPartBy') {
                    this.queryParam['probPart'] = main.probPart
                }
                if (this.typeBy == 'statusBy') {
                    this.queryParam['status'] = main.moStatus
                }
                if (this.typeBy == 'requesterBy') {
                    this.queryParam['moRequester'] = main.moRequester
                }
                if (this.typeBy == 'lineBy') {
                    for (var i = 0; i < this.factoryTree.length; i++) {
                        var factorys = this.factoryTree[i]
                        var arr = []
                        arr.push({
                            label: factorys.deptName,
                            id: factorys.deptID,
                            value: JSON.stringify(factorys.child),
                            deptLevel: factorys.deptLevel,
                            parent: 0,
                            child: factorys.child
                        })

                        var shop = factorys.child
                        for (var j = 0; j < shop.length; j++) {
                            var arr = []
                            arr.push({
                                label: shop[j].deptName,
                                id: shop[j].deptID,
                                value: JSON.stringify(shop[j].child),
                                deptLevel: shop[j].deptLevel,
                                parent: 0,
                                child: shop[j].child
                            })

                            var vsm = shop[j].child
                            for (var v = 0; v < vsm.length; v++) {
                                var arr = []
                                arr.push({
                                    label: vsm[v].deptName,
                                    id: vsm[v].deptID,
                                    value: JSON.stringify(vsm[v].child),
                                    deptLevel: vsm[v].deptLevel,
                                    parent: 0,
                                    child: vsm[v].child
                                })

                                var line = vsm[v].child
                                for (var l = 0; l < line.length; l++) {
                                    if (line[l].deptID == main.lineId) {
                                        var arr = []
                                        arr.push({
                                            label: line[l].deptName,
                                            id: line[l].deptID,
                                            value: JSON.stringify(line[l].child),
                                            deptLevel: line[l].deptLevel,
                                            parent: 0,
                                            child: line[l].child
                                        })
                                        this.queryParam['lineId'] = line[l].deptID
                                        this.queryParam['vsmId'] = vsm[v].deptID
                                        this.queryParam['shopId'] = shop[j].deptID
                                        this.queryParam['fcId'] = factorys.deptID
                                    }
                                }
                            }
                        }
                    }
                }
                if (this.typeBy == 'shopBy') {

                    for (var i = 0; i < this.factoryTree.length; i++) {
                        var factorys = this.factoryTree[i]
                        var arr = []
                        arr.push({
                            label: factorys.deptName,
                            id: factorys.deptID,
                            value: JSON.stringify(factorys.child),
                            deptLevel: factorys.deptLevel,
                            parent: 0,
                            child: factorys.child
                        })

                        var shop = factorys.child
                        for (var j = 0; j < shop.length; j++) {
                            if (shop[j].deptID == main.shopId) {
                                var arr = []
                                arr.push({
                                    label: shop[j].deptName,
                                    id: shop[j].deptID,
                                    value: JSON.stringify(shop[j].child),
                                    deptLevel: shop[j].deptLevel,
                                    parent: 0,
                                    child: shop[j].child
                                })
                                this.queryParam['shopId'] = shop[j].deptID
                                this.queryParam['fcId'] = factorys.deptID
                            }
                        }
                    }
                }
                this.$router.push({
                    name: 'mainorderlist',
                    params: {
                        queryParam: this.queryParam
                    }
                })
            },
            exportStatistics: function() {
                var self = this
                self.exportMainOrderList = []
                self.excelData = []
                self.queryParam = {}
                if (!self.typeDissection) {
                    self.$message.error('类型分列不能为空')
                    return
                }

                var querydata = {
                    pageNum: self.searchParams.pageNumber,
                    pageSize: self.searchParams.pageSize
                }

                if (self.searchParams.startTime != '' && self.searchParams.endTime != '') {
                    querydata['startTime'] = self.searchParams.startTime
                    querydata['endTime'] = self.searchParams.endTime
                }
                if (self.mechanism.fcCode != undefined && self.mechanism.fcCode != '') {
                    querydata['fcCode'] = JSON.parse(self.mechanism.fcCode).deptCode
                }
                if (self.mechanism.shopCode != undefined && self.mechanism.shopCode != '') {
                    querydata['shopCode'] = JSON.parse(self.mechanism.shopCode).deptCode
                }
                if (self.mechanism.sectionCode && self.mechanism.sectionCode != '') {
                    querydata['sectionCode'] = JSON.parse(self.mechanism.sectionCode).deptCode
                }
                if (self.mechanism.lineCode != undefined && self.mechanism.lineCode != '') {
                    querydata['lineCode'] = JSON.parse(self.mechanism.lineCode).deptCode
                }
                if (self.devCode != '') {
                    querydata['devCode'] = self.searchParams.devCode
                }
                if (self.searchParams.responser != '') {
                    querydata['andonRespUserName'] = self.searchParams.andonRespUserName
                }
                if (self.searchParams.probPart != '') {
                    querydata['probPart'] = self.searchParams.probPart
                }
                if (self.searchParams.andonStatus != '') {
                    querydata['andonStatus'] = self.searchParams.andonStatus
                }
                if (self.searchParams.pubUserName != '') {
                    querydata['pubUserName'] = self.searchParams.pubUserName
                }
                if (self.searchParams.responseTimeQueryHour != '') {
                    querydata['responseTimeQueryHour'] = self.searchParams.responseTimeQueryHour
                    querydata['responseTimeQuery'] = parseInt(self.searchParams.responseTimeQueryHour * 3600)
                }
                if (self.searchParams.probTimeQueryHour != '') {
                    querydata['probTimeQueryHour'] = self.searchParams.probTimeQueryHour
                    querydata['probTimeQuery'] = parseInt(self.searchParams.probTimeQueryHour * 3600)
                }
                if (self.typeDissection != '') {
                    querydata['typeDissection'] = self.typeDissection
                }
                if (self.searchParams.moHasTrans != '') {
                    querydata['moHasTrans'] = self.searchParams.moHasTrans
                }
                exportCostStatistics(querydata).then(function(resp) {
                    self.exportMainOrderList = resp.data
                    console.log(self.exportMainOrderList.length)

                    if (self.typeDissection == 'dayBy') {
                        self.exportDayList()
                    } else if (self.typeDissection == 'devCodeBy') {
                        self.exportDevNumberList()
                    } else if (self.typeDissection == 'responserBy') {
                        self.exportResponserList()
                    } else if (self.typeDissection == 'probPartBy') {
                        self.exportProbPartList()
                    } else if (self.typeDissection == 'statusBy') {
                        self.exportStatusList()
                    } else if (self.typeDissection == 'requesterBy') {
                        self.exportRequesterList()
                    } else if (self.typeDissection == 'lineBy') {
                        self.exportLineList()
                    } else if (self.typeDissection == 'shopBy') {
                        self.exportShopList()
                    }
                })
            },
            formatJson: function(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            exportDayList: function() {
                for (let i = 0; i < this.exportMainOrderList.length; i++) {
                    var data = {}
                    data['createTime'] = this.exportMainOrderList[i].createTime
                    data['sumCount'] = this.exportMainOrderList[i].sumCount
                    data['responseTime'] = this.exportMainOrderList[i].responseTime != null ? String(parseFloat(this.exportMainOrderList[i].responseTime) / 3600).substring(0, String(parseFloat(this.exportMainOrderList[i].responseTime) / 3600).indexOf('.') + 4) : ''
                    data['avgResponseTime'] = this.exportMainOrderList[i].responseTime != null ? String(parseFloat(this.exportMainOrderList[i].responseTime) / 3600 / (this.exportMainOrderList[i].sumCount)).substring(0, String(parseFloat(this.exportMainOrderList[i].responseTime) / 3600 / (this.exportMainOrderList[i].sumCount)).indexOf('.') + 4) : ''
                    data['repairTime'] = this.exportMainOrderList[i].repairTime != null ? String(parseFloat(this.exportMainOrderList[i].repairTime) / 3600).substring(0, String(parseFloat(this.exportMainOrderList[i].repairTime) / 3600).indexOf('.') + 4) : ''
                    data['probTime'] = this.exportMainOrderList[i].probTime != null ? String(parseFloat(this.exportMainOrderList[i].probTime) / 3600).substring(0, String(parseFloat(this.exportMainOrderList[i].probTime) / 3600).indexOf('.') + 4) : ''
                    //data['recoveryCount'] = this.exportMainOrderList[i].recoveryCount != null ? String(parseFloat(this.exportMainOrderList[i].recoveryCount / this.exportMainOrderList[i].sumCount)).substring(0, String(parseFloat(this.exportMainOrderList[i].recoveryCount / this.exportMainOrderList[i].sumCount)).indexOf('.') + 4) : ''
                    data['MTBF'] = this.exportMainOrderList[i].totalTime != null ? String(parseFloat(this.exportMainOrderList[i].totalTime) / 3600 / (this.exportMainOrderList[i].sumCount)).substring(0, String(parseFloat(this.exportMainOrderList[i].totalTime) / 3600 / (this.exportMainOrderList[i].sumCount)).indexOf('.') + 4) : ''
                    data['MTTR'] = this.exportMainOrderList[i].repairTime != null ? String(parseFloat(this.exportMainOrderList[i].repairTime) / 3600 / (this.exportMainOrderList[i].sumCount)).substring(0, String(parseFloat(this.exportMainOrderList[i].repairTime) / 3600 / (this.exportMainOrderList[i].sumCount)).indexOf('.') + 4) : ''
                    this.excelData.push(data)
                }
                this.exportDay()
            },
            exportDay: function() {
                const tHeader = ['报修日期', '次数', '响应时长(时)', '平均响应时长(时)', '系统记录维修时长(时)',
                    '故障总时长(时)', /*'两小时修复率',*/ 'MTBF', 'MTTR']
                const filterVal = ['createTime', 'sumCount', 'responseTime', 'avgResponseTime', 'repairTime',
                    'probTime', /*'recoveryCount',*/ 'MTBF', 'MTTR']
                export_json_to_excel(tHeader, this.formatJson(filterVal, this.excelData), '日期-维修统计')
            },
            exportDevNumberList: function() {
                for (let i = 0; i < this.exportMainOrderList.length; i++) {
                    var data = {}
                    data['devName'] = this.exportMainOrderList[i].devName
                    data['devCode'] = this.exportMainOrderList[i].devCode
                    data['sumCount'] = this.exportMainOrderList[i].sumCount
                    data['responseTime'] = this.exportMainOrderList[i].responseTime != null ? String(parseFloat(this.exportMainOrderList[i].responseTime) / 3600).substring(0, String(parseFloat(this.exportMainOrderList[i].responseTime) / 3600).indexOf('.') + 4) : ''
                    data['avgResponseTime'] = this.exportMainOrderList[i].responseTime != null ? String(parseFloat(this.exportMainOrderList[i].responseTime) / 3600 / (this.exportMainOrderList[i].sumCount)).substring(0, String(parseFloat(this.exportMainOrderList[i].responseTime) / 3600 / (this.exportMainOrderList[i].sumCount)).indexOf('.') + 4) : ''
                    data['repairTime'] = this.exportMainOrderList[i].repairTime != null ? String(parseFloat(this.exportMainOrderList[i].repairTime) / 3600).substring(0, String(parseFloat(this.exportMainOrderList[i].repairTime) / 3600).indexOf('.') + 4) : ''
                    data['probTime'] = this.exportMainOrderList[i].probTime != null ? String(parseFloat(this.exportMainOrderList[i].probTime) / 3600).substring(0, String(parseFloat(this.exportMainOrderList[i].probTime) / 3600).indexOf('.') + 4) : ''
                    //data['recoveryCount'] = this.exportMainOrderList[i].recoveryCount != null ? String(parseFloat(this.exportMainOrderList[i].recoveryCount / this.exportMainOrderList[i].sumCount)).substring(0, String(parseFloat(this.exportMainOrderList[i].recoveryCount / this.exportMainOrderList[i].sumCount)).indexOf('.') + 4) : ''
                    data['MTBF'] = this.exportMainOrderList[i].totalTime != null ? String(parseFloat(this.exportMainOrderList[i].totalTime) / 3600 / (this.exportMainOrderList[i].sumCount)).substring(0, String(parseFloat(this.exportMainOrderList[i].totalTime) / 3600 / (this.exportMainOrderList[i].sumCount)).indexOf('.') + 4) : ''
                    data['MTTR'] = this.exportMainOrderList[i].repairTime != null ? String(parseFloat(this.exportMainOrderList[i].repairTime) / 3600 / (this.exportMainOrderList[i].sumCount)).substring(0, String(parseFloat(this.exportMainOrderList[i].repairTime) / 3600 / (this.exportMainOrderList[i].sumCount)).indexOf('.') + 4) : ''
                    this.excelData.push(data)
                }
                this.exportDevNumber()
            },
            exportDevNumber: function() {
                const tHeader = ['设备名称', '设备编号', '次数', '响应时长(时)', '平均响应时长(时)', '系统记录维修时长(时)',
                    '故障总时长(时)', /*'两小时修复率',*/ 'MTBF', 'MTTR']
                const filterVal = ['devName', 'devCode', 'sumCount', 'responseTime', 'avgResponseTime', 'repairTime',
                    'probTime', /*'recoveryCount',*/ 'MTBF', 'MTTR']
                export_json_to_excel(tHeader, this.formatJson(filterVal, this.excelData), '设备-维修统计')
            },

            exportResponserList: function() {
                for (let i = 0; i < this.exportMainOrderList.length; i++) {
                    var data = {}
                    console.log(this.exportMainOrderList.length)
                    data['andonRespUserName'] = this.exportMainOrderList[i].andonRespUserName
                    data['sumCount'] = this.exportMainOrderList[i].sumCount
                    data['responseTime'] = this.exportMainOrderList[i].responseTime != null ? String(parseFloat(this.exportMainOrderList[i].responseTime) / 3600).substring(0, String(parseFloat(this.exportMainOrderList[i].responseTime) / 3600).indexOf('.') + 4) : ''
                    data['avgResponseTime'] = this.exportMainOrderList[i].responseTime != null ? String(parseFloat(this.exportMainOrderList[i].responseTime) / 3600 / (this.exportMainOrderList[i].sumCount)).substring(0, String(parseFloat(this.exportMainOrderList[i].responseTime) / 3600 / (this.exportMainOrderList[i].sumCount)).indexOf('.') + 4) : ''
                    data['repairTime'] = this.exportMainOrderList[i].repairTime != null ? String(parseFloat(this.exportMainOrderList[i].repairTime) / 3600).substring(0, String(parseFloat(this.exportMainOrderList[i].repairTime) / 3600).indexOf('.') + 4) : ''
                    data['probTime'] = this.exportMainOrderList[i].probTime != null ? String(parseFloat(this.exportMainOrderList[i].probTime) / 3600).substring(0, String(parseFloat(this.exportMainOrderList[i].probTime) / 3600).indexOf('.') + 4) : ''
                    //data['recoveryCount'] = this.exportMainOrderList[i].recoveryCount != null ? String(parseFloat(this.exportMainOrderList[i].recoveryCount / this.exportMainOrderList[i].sumCount)).substring(0, String(parseFloat(this.exportMainOrderList[i].recoveryCount / this.exportMainOrderList[i].sumCount)).indexOf('.') + 4) : ''
                    data['MTBF'] = this.exportMainOrderList[i].totalTime != null ? String(parseFloat(this.exportMainOrderList[i].totalTime) / 3600 / (this.exportMainOrderList[i].sumCount)).substring(0, String(parseFloat(this.exportMainOrderList[i].totalTime) / 3600 / (this.exportMainOrderList[i].sumCount)).indexOf('.') + 4) : ''
                    data['MTTR'] = this.exportMainOrderList[i].repairTime != null ? String(parseFloat(this.exportMainOrderList[i].repairTime) / 3600 / (this.exportMainOrderList[i].sumCount)).substring(0, String(parseFloat(this.exportMainOrderList[i].repairTime) / 3600 / (this.exportMainOrderList[i].sumCount)).indexOf('.') + 4) : ''
                    this.excelData.push(data)
                }
                this.exportResponser()
            },
            exportResponser: function() {
                const tHeader = ['维修人', '次数', '响应时长(时)', '平均响应时长(时)', '系统记录维修时长(时)',
                    '故障总时长(时)', /*'两小时修复率',*/ 'MTBF', 'MTTR']
                const filterVal = ['andonRespUserName', 'sumCount', 'responseTime', 'avgResponseTime', 'repairTime',
                    'probTime', /*'recoveryCount',*/ 'MTBF', 'MTTR']
                export_json_to_excel(tHeader, this.formatJson(filterVal, this.excelData), '维修人-维修统计')
            },
            exportProbPartList: function() {
                for (let i = 0; i < this.exportMainOrderList.length; i++) {
                    var data = {}
                    data['probPart'] = this.exportMainOrderList[i].probPart
                    data['sumCount'] = this.exportMainOrderList[i].sumCount
                    data['responseTime'] = this.exportMainOrderList[i].responseTime != null ? String(parseFloat(this.exportMainOrderList[i].responseTime) / 3600).substring(0, String(parseFloat(this.exportMainOrderList[i].responseTime) / 3600).indexOf('.') + 4) : ''
                    data['avgResponseTime'] = this.exportMainOrderList[i].responseTime != null ? String(parseFloat(this.exportMainOrderList[i].responseTime) / 3600 / (this.exportMainOrderList[i].sumCount)).substring(0, String(parseFloat(this.exportMainOrderList[i].responseTime) / 3600 / (this.exportMainOrderList[i].sumCount)).indexOf('.') + 4) : ''
                    data['repairTime'] = this.exportMainOrderList[i].repairTime != null ? String(parseFloat(this.exportMainOrderList[i].repairTime) / 3600).substring(0, String(parseFloat(this.exportMainOrderList[i].repairTime) / 3600).indexOf('.') + 4) : ''
                    data['probTime'] = this.exportMainOrderList[i].probTime != null ? String(parseFloat(this.exportMainOrderList[i].probTime) / 3600).substring(0, String(parseFloat(this.exportMainOrderList[i].probTime) / 3600).indexOf('.') + 4) : ''
                    //data['recoveryCount'] = this.exportMainOrderList[i].recoveryCount != null ? String(parseFloat(this.exportMainOrderList[i].recoveryCount / this.exportMainOrderList[i].sumCount)).substring(0, String(parseFloat(this.exportMainOrderList[i].recoveryCount / this.exportMainOrderList[i].sumCount)).indexOf('.') + 4) : ''
                    data['MTBF'] = this.exportMainOrderList[i].totalTime != null ? String(parseFloat(this.exportMainOrderList[i].totalTime) / 3600 / (this.exportMainOrderList[i].sumCount)).substring(0, String(parseFloat(this.exportMainOrderList[i].totalTime) / 3600 / (this.exportMainOrderList[i].sumCount)).indexOf('.') + 4) : ''
                    data['MTTR'] = this.exportMainOrderList[i].repairTime != null ? String(parseFloat(this.exportMainOrderList[i].repairTime) / 3600 / (this.exportMainOrderList[i].sumCount)).substring(0, String(parseFloat(this.exportMainOrderList[i].repairTime) / 3600 / (this.exportMainOrderList[i].sumCount)).indexOf('.') + 4) : ''
                    this.excelData.push(data)
                }
                this.exportProbPart()
            },
            exportProbPart: function() {
                const tHeader = ['故障部位', '次数', '响应时长(时)', '平均响应时长(时)', '系统记录维修时长(时)',
                    '故障总时长(时)', /*'两小时修复率',*/ 'MTBF', 'MTTR']
                const filterVal = ['probPart', 'sumCount', 'responseTime', 'avgResponseTime', 'repairTime',
                    'probTime', /*'recoveryCount',*/ 'MTBF', 'MTTR']
                export_json_to_excel(tHeader, this.formatJson(filterVal, this.excelData), '故障部位-维修统计')
            },
            exportStatusList: function() {
                debugger
                var status = ''
                for (let i = 0; i < this.exportMainOrderList.length; i++) {

                    if (this.exportMainOrderList[i].andonStatus == 'create') {
                        status = '待接单'
                    } else if (this.exportMainOrderList[i].andonStatus == 'wait_complete') {
                        status = '待维修'
                    } else if (this.exportMainOrderList[i].andonStatus == 'wait_accept') {
                        status = '待完成'
                    } else if (this.exportMainOrderList[i].andonStatus == 'complete') {
                        status = '已完成'
                    }
                    var data = {}
                    data['andonStatus'] = status
                    data['sumCount'] = this.exportMainOrderList[i].sumCount
                    data['responseTime'] = this.exportMainOrderList[i].responseTime != null ? String(parseFloat(this.exportMainOrderList[i].responseTime) / 3600).substring(0, String(parseFloat(this.exportMainOrderList[i].responseTime) / 3600).indexOf('.') + 4) : ''
                    data['avgResponseTime'] = this.exportMainOrderList[i].responseTime != null ? String(parseFloat(this.exportMainOrderList[i].responseTime) / 3600 / (this.exportMainOrderList[i].sumCount)).substring(0, String(parseFloat(this.exportMainOrderList[i].responseTime) / 3600 / (this.exportMainOrderList[i].sumCount)).indexOf('.') + 4) : ''
                    data['repairTime'] = this.exportMainOrderList[i].repairTime != null ? String(parseFloat(this.exportMainOrderList[i].repairTime) / 3600).substring(0, String(parseFloat(this.exportMainOrderList[i].repairTime) / 3600).indexOf('.') + 4) : ''
                    data['probTime'] = this.exportMainOrderList[i].probTime != null ? String(parseFloat(this.exportMainOrderList[i].probTime) / 3600).substring(0, String(parseFloat(this.exportMainOrderList[i].probTime) / 3600).indexOf('.') + 4) : ''
                    //data['recoveryCount'] = this.exportMainOrderList[i].recoveryCount != null ? String(parseFloat(this.exportMainOrderList[i].recoveryCount / this.exportMainOrderList[i].sumCount)).substring(0, String(parseFloat(this.exportMainOrderList[i].recoveryCount / this.exportMainOrderList[i].sumCount)).indexOf('.') + 4) : ''
                    data['MTBF'] = this.exportMainOrderList[i].totalTime != null ? String(parseFloat(this.exportMainOrderList[i].totalTime) / 3600 / (this.exportMainOrderList[i].sumCount)).substring(0, String(parseFloat(this.exportMainOrderList[i].totalTime) / 3600 / (this.exportMainOrderList[i].sumCount)).indexOf('.') + 4) : ''
                    data['MTTR'] = this.exportMainOrderList[i].repairTime != null ? String(parseFloat(this.exportMainOrderList[i].repairTime) / 3600 / (this.exportMainOrderList[i].sumCount)).substring(0, String(parseFloat(this.exportMainOrderList[i].repairTime) / 3600 / (this.exportMainOrderList[i].sumCount)).indexOf('.') + 4) : ''
                    this.excelData.push(data)
                }
                this.exportStatus()
            },
            exportStatus: function() {
                const tHeader = ['状态', '次数', '响应时长(时)', '平均响应时长(时)', '系统记录维修时长(时)',
                    '故障总时长(时)', /*'两小时修复率',*/ 'MTBF', 'MTTR']
                const filterVal = ['andonStatus', 'sumCount', 'responseTime', 'avgResponseTime', 'repairTime',
                    'probTime', /*'recoveryCount',*/ 'MTBF', 'MTTR']
                export_json_to_excel(tHeader, this.formatJson(filterVal, this.excelData), '工单状态-维修统计')
            },
            exportRequesterList: function() {
                for (let i = 0; i < this.exportMainOrderList.length; i++) {
                    var data = {}
                    data['pubUserName'] = this.exportMainOrderList[i].pubUserName
                    data['sumCount'] = this.exportMainOrderList[i].sumCount
                    data['responseTime'] = this.exportMainOrderList[i].responseTime != null ? String(parseFloat(this.exportMainOrderList[i].responseTime) / 3600).substring(0, String(parseFloat(this.exportMainOrderList[i].responseTime) / 3600).indexOf('.') + 4) : ''
                    data['avgResponseTime'] = this.exportMainOrderList[i].responseTime != null ? String(parseFloat(this.exportMainOrderList[i].responseTime) / 3600 / (this.exportMainOrderList[i].sumCount)).substring(0, String(parseFloat(this.exportMainOrderList[i].responseTime) / 3600 / (this.exportMainOrderList[i].sumCount)).indexOf('.') + 4) : ''
                    data['repairTime'] = this.exportMainOrderList[i].repairTime != null ? String(parseFloat(this.exportMainOrderList[i].repairTime) / 3600).substring(0, String(parseFloat(this.exportMainOrderList[i].repairTime) / 3600).indexOf('.') + 4) : ''
                    data['probTime'] = this.exportMainOrderList[i].probTime != null ? String(parseFloat(this.exportMainOrderList[i].probTime) / 3600).substring(0, String(parseFloat(this.exportMainOrderList[i].probTime) / 3600).indexOf('.') + 4) : ''
                    //data['recoveryCount'] = this.exportMainOrderList[i].recoveryCount != null ? String(parseFloat(this.exportMainOrderList[i].recoveryCount / this.exportMainOrderList[i].sumCount)).substring(0, String(parseFloat(this.exportMainOrderList[i].recoveryCount / this.exportMainOrderList[i].sumCount)).indexOf('.') + 4) : ''
                    data['MTBF'] = this.exportMainOrderList[i].totalTime != null ? String(parseFloat(this.exportMainOrderList[i].totalTime) / 3600 / (this.exportMainOrderList[i].sumCount)).substring(0, String(parseFloat(this.exportMainOrderList[i].totalTime) / 3600 / (this.exportMainOrderList[i].sumCount)).indexOf('.') + 4) : ''
                    data['MTTR'] = this.exportMainOrderList[i].repairTime != null ? String(parseFloat(this.exportMainOrderList[i].repairTime) / 3600 / (this.exportMainOrderList[i].sumCount)).substring(0, String(parseFloat(this.exportMainOrderList[i].repairTime) / 3600 / (this.exportMainOrderList[i].sumCount)).indexOf('.') + 4) : ''
                    this.excelData.push(data)
                }
                this.exportRequester()
            },
            exportRequester: function() {
                const tHeader = ['报修人', '次数', '响应时长(时)', '平均响应时长(时)', '系统记录维修时长(时)',
                    '故障总时长(时)', /*'两小时修复率',*/ 'MTBF', 'MTTR']
                const filterVal = ['pubUserName', 'sumCount', 'responseTime', 'avgResponseTime', 'repairTime',
                    'probTime', /*'recoveryCount',*/ 'MTBF', 'MTTR']
                export_json_to_excel(tHeader, this.formatJson(filterVal, this.excelData), '报修人-维修统计')
            },
            exportLineList: function() {
                for (let i = 0; i < this.exportMainOrderList.length; i++) {
                    var data = {}
                    data['lineName'] = this.exportMainOrderList[i].lineName
                    data['sumCount'] = this.exportMainOrderList[i].sumCount
                    data['responseTime'] = this.exportMainOrderList[i].responseTime != null ? String(parseFloat(this.exportMainOrderList[i].responseTime) / 3600).substring(0, String(parseFloat(this.exportMainOrderList[i].responseTime) / 3600).indexOf('.') + 4) : ''
                    data['avgResponseTime'] = this.exportMainOrderList[i].responseTime != null ? String(parseFloat(this.exportMainOrderList[i].responseTime) / 3600 / (this.exportMainOrderList[i].sumCount)).substring(0, String(parseFloat(this.exportMainOrderList[i].responseTime) / 3600 / (this.exportMainOrderList[i].sumCount)).indexOf('.') + 4) : ''
                    data['repairTime'] = this.exportMainOrderList[i].repairTime != null ? String(parseFloat(this.exportMainOrderList[i].repairTime) / 3600).substring(0, String(parseFloat(this.exportMainOrderList[i].repairTime) / 3600).indexOf('.') + 4) : ''
                    data['probTime'] = this.exportMainOrderList[i].probTime != null ? String(parseFloat(this.exportMainOrderList[i].probTime) / 3600).substring(0, String(parseFloat(this.exportMainOrderList[i].probTime) / 3600).indexOf('.') + 4) : ''
                    //data['recoveryCount'] = this.exportMainOrderList[i].recoveryCount != null ? String(parseFloat(this.exportMainOrderList[i].recoveryCount / this.exportMainOrderList[i].sumCount)).substring(0, String(parseFloat(this.exportMainOrderList[i].recoveryCount / this.exportMainOrderList[i].sumCount)).indexOf('.') + 4) : ''
                    data['MTBF'] = this.exportMainOrderList[i].totalTime != null ? String(parseFloat(this.exportMainOrderList[i].totalTime) / 3600 / (this.exportMainOrderList[i].sumCount)).substring(0, String(parseFloat(this.exportMainOrderList[i].totalTime) / 3600 / (this.exportMainOrderList[i].sumCount)).indexOf('.') + 4) : ''
                    data['MTTR'] = this.exportMainOrderList[i].repairTime != null ? String(parseFloat(this.exportMainOrderList[i].repairTime) / 3600 / (this.exportMainOrderList[i].sumCount)).substring(0, String(parseFloat(this.exportMainOrderList[i].repairTime) / 3600 / (this.exportMainOrderList[i].sumCount)).indexOf('.') + 4) : ''
                    this.excelData.push(data)
                }
                this.exportRequester()
            },
            exportLine: function() {
                const tHeader = ['产线', '次数', '响应时长(时)', '平均响应时长(时)', '系统记录维修时长(时)',
                    '故障总时长(时)', '两小时修复率', 'MTBF', 'MTTR']
                const filterVal = ['lineName', 'sumCount', 'responseTime', 'avgResponseTime', 'repairTime',
                    'probTime', 'recoveryCount', 'MTBF', 'MTTR']
                export_json_to_excel(tHeader, this.formatJson(filterVal, this.excelData), '产线-维修统计')
            },
            exportShopList: function() {
                for (let i = 0; i < this.exportMainOrderList.length; i++) {
                    var data = {}
                    data['shopName'] = this.exportMainOrderList[i].shopName
                    data['sumCount'] = this.exportMainOrderList[i].sumCount
                    data['responseTime'] = this.exportMainOrderList[i].responseTime != null ? String(parseFloat(this.exportMainOrderList[i].responseTime) / 3600).substring(0, String(parseFloat(this.exportMainOrderList[i].responseTime) / 3600).indexOf('.') + 4) : ''
                    data['avgResponseTime'] = this.exportMainOrderList[i].responseTime != null ? String(parseFloat(this.exportMainOrderList[i].responseTime) / 3600 / (this.exportMainOrderList[i].sumCount)).substring(0, String(parseFloat(this.exportMainOrderList[i].responseTime) / 3600 / (this.exportMainOrderList[i].sumCount)).indexOf('.') + 4) : ''
                    data['repairTime'] = this.exportMainOrderList[i].repairTime != null ? String(parseFloat(this.exportMainOrderList[i].repairTime) / 3600).substring(0, String(parseFloat(this.exportMainOrderList[i].repairTime) / 3600).indexOf('.') + 4) : ''
                    data['probTime'] = this.exportMainOrderList[i].probTime != null ? String(parseFloat(this.exportMainOrderList[i].probTime) / 3600).substring(0, String(parseFloat(this.exportMainOrderList[i].probTime) / 3600).indexOf('.') + 4) : ''
                    //data['recoveryCount'] = this.exportMainOrderList[i].recoveryCount != null ? String(parseFloat(this.exportMainOrderList[i].recoveryCount / this.exportMainOrderList[i].sumCount)).substring(0, String(parseFloat(this.exportMainOrderList[i].recoveryCount / this.exportMainOrderList[i].sumCount)).indexOf('.') + 4) : ''
                    data['MTBF'] = this.exportMainOrderList[i].totalTime != null ? String(parseFloat(this.exportMainOrderList[i].totalTime) / 3600 / (this.exportMainOrderList[i].sumCount)).substring(0, String(parseFloat(this.exportMainOrderList[i].totalTime) / 3600 / (this.exportMainOrderList[i].sumCount)).indexOf('.') + 4) : ''
                    data['MTTR'] = this.exportMainOrderList[i].repairTime != null ? String(parseFloat(this.exportMainOrderList[i].repairTime) / 3600 / (this.exportMainOrderList[i].sumCount)).substring(0, String(parseFloat(this.exportMainOrderList[i].repairTime) / 3600 / (this.exportMainOrderList[i].sumCount)).indexOf('.') + 4) : ''
                    this.excelData.push(data)
                }
                this.exportShop()
            },
            exportShop: function() {
                const tHeader = ['车间', '次数', '响应时长(时)', '平均响应时长(时)', '系统记录维修时长(时)',
                    '故障总时长(时)', /*'两小时修复率',*/ 'MTBF', 'MTTR']
                const filterVal = ['shopName', 'sumCount', 'responseTime', 'avgResponseTime', 'repairTime',
                    'probTime', /*'recoveryCount',*/ 'MTBF', 'MTTR']
                export_json_to_excel(tHeader, this.formatJson(filterVal, this.excelData), '车间-维修统计')
            }
            /* getRowChange:function(main){
              if(this.typeBy=='dayBy'){
                this.queryParam['startTime']=main.moRequestTime
                this.queryParam['endTime']=main.moRequestTime
              }
              if(this.typeBy=='devNumberBy'){
                this.queryParam['devCode']=main.devCode
              }
              if(this.typeBy=='responserBy'){
                this.queryParam['moResponser']=main.responser
              }
              if(this.typeBy=='probPartBy'){
                this.queryParam['probPart']=main.probPart
              }
              if(this.typeBy=='statusBy'){
                this.queryParam['status']=main.moStatus
              }
              if(this.typeBy=='requesterBy'){
                this.queryParam['moRequester']=main.moRequester
              }
              if(this.typeBy=='lineBy'){
                for (var i = 0; i < this.factoryTree.length; i++) {
                        var factorys = this.factoryTree[i]
                            var arr = []
                          arr.push({
                              label: factorys.deptName,
                              id: factorys.deptID,
                              value: JSON.stringify(factorys.child),
                              deptLevel: factorys.deptLevel,
                              parent: 0,
                              child: factorys.child
                          });

                        var shop = factorys.child
                        for (var j = 0; j < shop.length; j++) {
                              var arr = []
                              arr.push({
                                  label: shop[j].deptName,
                                  id: shop[j].deptID,
                                  value: JSON.stringify(shop[j].child),
                                  deptLevel: shop[j].deptLevel,
                                  parent: 0,
                                  child: shop[j].child
                              });

                          var vsm = shop[j].child
                          for (var v = 0; v < vsm.length; v++) {
                                  var arr = []
                                  arr.push({
                                    label: vsm[v].deptName,
                                    id: vsm[v].deptID,
                                    value: JSON.stringify(vsm[v].child),
                                    deptLevel: vsm[v].deptLevel,
                                    parent: 0,
                                    child: vsm[v].child
                                  });

                              var line = vsm[v].child;
                              for (var l = 0; l < line.length; l++) {
                                  if (line[l].deptID == main.lineId) {
                                    var arr = []
                                    arr.push({
                                        label: line[l].deptName,
                                        id: line[l].deptID,
                                        value: JSON.stringify(line[l].child),
                                        deptLevel: line[l].deptLevel,
                                        parent: 0,
                                        child: line[l].child
                                  });
                                    this.queryParam['lineId'] = line[l].deptID
                                    this.queryParam['vsmId'] = vsm[v].deptID
                                    this.queryParam['shopId'] = shop[j].deptID
                                    this.queryParam['fcId'] = factorys.deptID
                                  }
                              }
                          }
                        }
                  }
              }
              if(this.typeBy=='shopBy'){

                for (var i = 0; i < this.factoryTree.length; i++) {
                        var factorys = this.factoryTree[i]
                            var arr = []
                          arr.push({
                              label: factorys.deptName,
                              id: factorys.deptID,
                              value: JSON.stringify(factorys.child),
                              deptLevel: factorys.deptLevel,
                              parent: 0,
                              child: factorys.child
                          });

                        var shop = factorys.child
                        for (var j = 0; j < shop.length; j++) {
                          if(shop[j].deptID==main.shopId){
                              var arr = []
                              arr.push({
                                  label: shop[j].deptName,
                                  id: shop[j].deptID,
                                  value: JSON.stringify(shop[j].child),
                                  deptLevel: shop[j].deptLevel,
                                  parent: 0,
                                  child: shop[j].child
                              });
                                this.queryParam['shopId'] = shop[j].deptID
                                this.queryParam['fcId'] = factorys.deptID
                          }
                        }
                  }
               }
            } */

        }
    }
</script>
<style lang="scss" scoped>
    .box-card {
        width: 70%;
    }
</style>
